import { CommonData, IData } from '../Shared/common';
export class BaseEntity extends CommonData {
  OrgId: number;
  OrgName: string;
  UnitId: number;
  UnitName: string;
  CreateDate: Date;
  LastupdateDate: Date;
  LastUpdateBy : number
}


export interface IBaseEntity extends IData {
  OrgId: number;
  OrgName: string;
  UnitId: number;
  UnitName: string;
  CreateDate: Date;
  LastupdateDate: Date;
  LastUpdateBy: number
}
